import axios from 'axios'
import { string } from 'prop-types'

const ConsultaCep = {
  ViaCep: async (value = string.isRequired) =>
    await axios.get(`https://viacep.com.br/ws/${value}/json/`),
}

export default ConsultaCep
